import React, { FC } from "react";
import { Link, useParams } from "react-router-dom";
import Button from "../../../components/UI/button/GgButton";
import { formatCalcName } from "../../../utils";

interface ICalcCard {
  calcType: string;
  data: any;
}

const CalcCard: FC<ICalcCard> = ({ calcType}) => {
  const { id } = useParams();
  return (
        <div className="card-item">
      <div className="card-info">
        <div className="card-title">{formatCalcName(calcType)}</div>
        {/* <div className="dates">
          <span className="date">Created: {"3.06.21 (11:10:54)"}</span>
          <span className="date"> / Updated: {"26.03.21 (12:10:51)"}</span>
        </div> */}
      </div>
      <div className="controls calc">
        <Link to={`/admin/control/users/${id}/${calcType}`}>
          <Button label="View details" stylesType="border" />
        </Link>
        {/* <Button 
        label="Delete"
        onPress={() => deleteCalcData()}
        /> */}
      </div>
    </div>
  );
};

export default CalcCard;
